import { Component, Input } from '@angular/core';
import { ApiCommunicationPref } from '@tytapp/api';

@Component({
    selector: 'tyt-notifications-category-settings',
    templateUrl: './notifications-category-settings.component.html',
    styleUrls: ['./notifications-category-settings.component.scss']
})
export class NotificationsCategorySettingsComponent {
    @Input() category: string;
    @Input() prefValues: boolean[];
    @Input() prefs: ApiCommunicationPref[];
}